export default {
  // For Cp Simulator
  PlugIn: {
    data: [
      [
        2,
        "1",
        "DataTransfer",
        {
          vendorId: "Autotoll",
          messageId: "ChargingDetails",
          data: {
            start_time: "2020-09-25T07:54:00.976Z",
            session_fee: "6.00",
            minutes_per_session: "15",
            session_count: "1",
            charging_fee: "6.00"
          }
        }
      ]
    ]
  }
}